export default __webpack_public_path__ + "static/Image050-Log_small-58a03af09748bed0ecfc42bbb1bf19fe.png";